module.exports = __webpack_public_path__ + "static/media/done_all_black_24dp.4e7dc92e.svg";